/* BNB top menu (Oct 2026)                                  assets/bnb-menu.js
   Phone menu only: Categories, Goals and Brands open and close in place,
   and the A-Z strip under Brands jumps to that letter.
   Uses one click listener on the page, so it works after the theme builds the drawer. */
(function () {
  if (window.bnbMenuReady) return;
  window.bnbMenuReady = true;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('[data-bnb-acc]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var item = btn.closest('.bnb-acc');
      var open = !item.classList.contains('is-open');
      var list = item.parentNode;
      if (list) {
        list.querySelectorAll('.bnb-acc.is-open').forEach(function (o) {
          if (o !== item) {
            o.classList.remove('is-open');
            var b = o.querySelector('[data-bnb-acc]');
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        });
      }
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var az = t.closest('[data-bnb-az]');
    if (az) {
      e.preventDefault();
      var box = az.closest('.bnb-m--brands');
      if (!box) return;
      box.querySelectorAll('[data-bnb-az]').forEach(function (x) { x.classList.toggle('is-on', x === az); });
      var target = box.querySelector('[data-bnb-letter="' + az.getAttribute('data-bnb-az') + '"]');
      if (!target) return;
      var scroller = target.closest('.mobile-navigation-drawer');
      if (scroller && scroller.scrollHeight > scroller.clientHeight) {
        scroller.scrollTop += target.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 72;
      } else {
        target.scrollIntoView();
      }
    }
  }, true);
})();

/* Floating buttons (Miles, 2 Nov 2026)
   1. Chat button (Shopify Inbox) sits low in the bottom-right corner (16px up).
      On phone product pages, while the add-to-cart bar is showing, it sits just above the bar.
      Inbox only offers "lowest / highest" style settings, so this sets the spot directly.
   2. "Earn points" launcher (Marsello) hidden on phones everywhere and on the Rewards page. */
(function () {
  if (window.bnbFloatReady) return;
  window.bnbFloatReady = true;

  var st = document.createElement('style');
  st.id = 'bnb-float-css';
  st.textContent =
    '@media (max-width:749.98px){#marsello-widget-root .cp-launcher{display:none!important}}' +
    'body:has(.bnbr-hero) #marsello-widget-root .cp-launcher{display:none!important}';
  (document.head || document.documentElement).appendChild(st);

  var GAP = 16;
  var phone = window.matchMedia('(max-width:749.98px)');

  function chatBox() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    var rt = host.shadowRoot.querySelector('shopify-agent-runtime');
    var root = rt && rt.shadowRoot;
    if (!root) return null;
    var btn = root.querySelector('button');
    if (!btn) return null;
    var el = btn;
    while (el && getComputedStyle(el).position !== 'absolute') el = el.parentElement;
    return el || null;
  }

  function place() {
    var box = chatBox();
    if (!box) return false;
    var bar = document.querySelector('bnb-sticky-atc.is-visible');
    /* the bar also stays hidden until the shopper scrolls past the main button (body.bnb-atc-passed) */
    if (bar && getComputedStyle(bar).visibility === 'hidden') bar = null;
    var b = GAP;
    if (bar && phone.matches) b = Math.round(bar.getBoundingClientRect().height) + 12;
    if (box.style.getPropertyValue('bottom') !== b + 'px') {
      box.style.setProperty('bottom', b + 'px', 'important');
      // first move is instant (no slide down on page load); later moves glide
      if (!box.__bnbPlaced) {
        box.__bnbPlaced = true;
        requestAnimationFrame(function () { box.style.setProperty('transition', 'bottom .25s ease'); });
      }
    }
    return true;
  }

  // Inbox can redraw its button; watch inside the chat widget for that instead of re-checking on a timer
  function watchChat() {
    var host = document.querySelector('shopify-chat');
    var rt = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    var root = rt && rt.shadowRoot;
    if (!root || root.__bnbWatched) return;
    root.__bnbWatched = true;
    new MutationObserver(function () { place(); }).observe(root, { childList: true, subtree: true });
  }

  function start() {
    new MutationObserver(function () { place(); setTimeout(place, 450); }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', place);
    // check every 100ms until the chat button first appears, so it lands in place right away; after
    // that, the watchers above handle changes (no timer left running, 3 Nov 2026)
    var tries = 0;
    var fast = setInterval(function () {
      tries++;
      if (place() || tries > 150) {
        clearInterval(fast);
        watchChat();
      }
    }, 100);
    place();
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();

/* Search dropdown tracking (Miles, 3 Nov 2026)
   Clicks in the header search dropdown that go straight to a product or collection skip the
   search results page, so GA4 never counted them as searches. This tags every dropdown link
   just before it is followed, so the page view in GA4 shows where the click came from:
     _bnbs = dd-best-3     best seller card, slot 3 (empty search box)
             dd-popular-1  popular search term, slot 1
             dd-recent-2   recent search, slot 2
             dd-product-1  product suggestion while typing, slot 1
             dd-collection-2  collection chip while typing, slot 2
             dd-all        "See all results"
     _bnbq = what the shopper had typed (typed suggestions only)
   In GA4: filter Page location contains "_bnbs=". The search script itself is not changed.
   On phones the panel sits on the page body, not inside the search form (see bnb-header-search.js),
   so links are matched by the panel (.bnb-hsuggest) and the panel's own form is used for the typed words. */
(function () {
  if (window.bnbSearchTagReady) return;
  window.bnbSearchTagReady = true;

  var KINDS = [
    ['bnb-hp__card', 'best'],
    ['bnb-hp__term', 'popular'],
    ['bnb-hp__recent', 'recent'],
    ['bnb-hsuggest__item', 'product'],
    ['bnb-hsuggest__chip', 'collection'],
    ['bnb-hsuggest__all', 'all']
  ];

  function kindOf(a) {
    for (var i = 0; i < KINDS.length; i++) if (a.classList.contains(KINDS[i][0])) return KINDS[i];
    return null;
  }

  function tag(a) {
    if (!a || a.dataset.bnbTagged === '1') return;
    var k = kindOf(a);
    if (!k) return;
    var box = a.closest('.bnb-hsuggest');
    if (!box) return;
    try {
      var u = new URL(a.getAttribute('href') || '', location.origin);
      if (u.origin !== location.origin) return;
      var label = 'dd-' + k[1];
      if (k[1] !== 'all') {
        var same = box.querySelectorAll('a.' + k[0]);
        var slot = Array.prototype.indexOf.call(same, a) + 1;
        if (slot > 0) label += '-' + slot;
      }
      u.searchParams.set('_bnbs', label);
      if (k[1] === 'product' || k[1] === 'collection') {
        var form2 = box.bnbForm || a.closest('form');
        var input = form2 && form2.querySelector('input[name="q"]');
        var typed = input && input.value.trim();
        if (typed) u.searchParams.set('_bnbq', typed.slice(0, 60));
      }
      a.setAttribute('href', u.pathname + u.search + u.hash);
      a.dataset.bnbTagged = '1';
    } catch (e) {}
  }

  function fromEvent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a');
    if (a) tag(a);
  }

  // pointerdown covers new-tab and long-press; click covers everything else
  document.addEventListener('pointerdown', fromEvent, true);
  document.addEventListener('click', fromEvent, true);

  // Enter on a highlighted dropdown item: the search script follows that item's link,
  // so tag every dropdown link in the form first
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!t || t.name !== 'q') return;
    var links = document.querySelectorAll('.bnb-hsuggest a');
    for (var i = 0; i < links.length; i++) tag(links[i]);
  }, true);
})();
